export const en = {
  // Navbar
  nav: {
    home: "Home",
    about: "About",
    expertise: "Expertise",
    services: "Our Services",
    methodology: "Methodology",
    employeMystere: "Mystery Employee",
    cities: "Our Cities",
    blog: "Blog",
    faq: "FAQ",
    contact: "Contact",
    cta: "Request an Audit",
  },

  // Footer
  footer: {
    navigation: "Navigation",
    ourCities: "Our Cities",
    contactTitle: "Contact",
    allCities: "All cities →",
    tagline: "Specialist mystery audit and mystery employee firm for any company with employees: industry, retail, logistics, offices, healthcare.",
    motto: "Discretion · Rigour · Excellence",
    rights: "Employé Incognito — All rights reserved",
    legal: "Legal Notice",
    privacy: "Privacy Policy",
    whatsapp: "(WhatsApp)",
  },

  // Contact form
  form: {
    firstName: "First Name *",
    lastName: "Last Name *",
    establishment: "Establishment Name *",
    function: "Position",
    email: "Professional Email *",
    phone: "Phone",
    typeLabel: "Establishment Type *",
    stars: "Star Rating (if hotel)",
    location: "Location (city, country)",
    message: "Describe your needs in detail *",
    consent: "I agree that my data will be processed in accordance with Employé Incognito's privacy policy as part of my request. *",
    submit: "Request Your Personalised Audit",
    sending: "Sending…",
    successTitle: "Request sent successfully",
    successText: "An expert will get back to you within",
    successDelay: "24 to 48 hours",
    errorText: "An error occurred. Please try again or contact us directly.",
    types: [
      "Hotel",
      "Restaurant",
      "Resort / Spa",
      "Travel Agency",
      "Premium Rental",
      "Tourist Establishment",
      "Hotel Group",
      "Retail / Shop",
      "Banking / Insurance",
      "Healthcare / Clinic",
      "Public Sector / Government",
      "Corporate / Enterprise",
      "Other",
    ],
  },

  // Homepage
  home: {
    badge: "Operational Immersion Firm — All Sectors",
    heroTitle: "We become your employees to reveal the",
    heroHighlight: "reality of your business",
    heroDesc: "Employé Incognito conducts discreet field immersions to identify invisible dysfunctions, process gaps, managerial issues and improvement opportunities. Internal audit, mystery employee, operational observation — every business sector.",
    videoSubtitle: "The audit that starts from within",
    videoTitle: "See what no one tells you",
    videoDesc: "Immersion reveals what dashboards, classic audits and reports cannot see.",
    sectorsSubtitle: "All Business Sectors",
    sectorsTitle: "Our Areas of Intervention",
    sectorsDesc: "Factory, store, warehouse, office, clinic or branch: wherever there are employees, there is a gap between what management sees and what teams experience. That is where we step in.",
    sectorsList: [
      { title: "Industry & Production", desc: "Factories, workshops, production sites: real safety, organisation, pace and social climate." },
      { title: "Retail & Networks", desc: "Stores, franchises, dealerships, large retail." },
      { title: "Logistics & Warehousing", desc: "Distribution centres, order picking, transport, supply chain." },
      { title: "Offices & Services", desc: "SMEs, headquarters, firms, agencies, multi-site companies." },
      { title: "Healthcare & Care", desc: "Clinics, medical centres, nursing homes, specialised facilities." },
      { title: "Customer Care & Construction", desc: "Call centres, building sites, field and mobile teams." },
    ],
    trustItems: ["Any company with employees", "100% confidential missions", "Report within 7 days"],
    gapSubtitle: "The leader's blind spot",
    gapTitle: "What you see. What your employees live.",
    gapLeftTitle: "Management's view",
    gapRightTitle: "What our employee discovers",
    gapLeft: ["Green dashboards", "Written, approved procedures", "Managers who are \"handling it\"", "Turnover deemed \"normal\""],
    gapRight: ["Daily process workarounds", "Instructions never applied on the ground", "Management silently demotivating teams", "Costly departures with clear causes"],
    concerneSubtitle: "Diagnosis",
    concerneTitle: "Your company is concerned if…",
    concerneItems: [
      "your reports say \"all is well\" but you have doubts.",
      "you suspect gaps between procedures and field reality.",
      "you run several sites, branches, stores or franchises.",
      "you face turnover or unexplained internal tensions.",
      "you want to understand what your teams really experience.",
      "you seek an unfiltered view of your organisation.",
    ],
    concerneCta: "Request an immersion",
    casesSubtitle: "Use Cases",
    casesTitle: "Real Immersion Examples",
    cases: [
      { sector: "Retail", title: "In-store integration", desc: "We integrate your point of sale as a salesperson to analyse commercial posture, lost sales, service quality and procedure compliance." },
      { sector: "Industry", title: "Production site immersion", desc: "We join your field teams to observe real safety, organisation, internal communication and operational gaps." },
      { sector: "Offices", title: "Corporate observation", desc: "Immersion in your teams to analyse real management, internal culture, processes and organisational efficiency." },
      { sector: "Logistics", title: "Warehouse immersion", desc: "We become a picker or forklift driver to measure pace, safety, lost time and relations with supervisors." },
    ],
    ctaPrimary: "Request Your Personalised Audit",
    ctaSecondary: "Discover Our Services",
    whoWeAre: "Who We Are",
    whoWeAreTitle: "The immersion firm for every company with employees",
    whoWeAreDesc: "Employé Incognito partners with leaders who want the truth from the ground. Our auditors join as real employees, in any type of company, to reveal what reports don't show: real organisation, management, social climate and profitability.",
    values: ["Absolute Discretion", "All Sectors", "Measurable Results"],
    valueDescs: [
      "Our auditors operate in complete confidentiality, just like real employees.",
      "Industry, retail, logistics, offices, healthcare, construction… wherever there are employees.",
      "Strategic reports with concrete performance indicators.",
    ],
    expertiseSubtitle: "Our Expertise",
    expertiseTitle: "Tailored field audits",
    services: [
      { title: "Immersive Mystery Employee", desc: "An auditor embedded in your teams as an employee to observe operational reality." },
      { title: "Social Climate & Management Audit", desc: "Reporting lines, motivation, real causes of turnover and internal tension." },
      { title: "Process & Compliance Audit", desc: "Gaps between written procedures and real practice: safety, quality, productivity." },
      { title: "Strategic Reports", desc: "Performance score, in-depth analysis and actionable improvement plan." },
    ],
    seeAllServices: "View All Services",
    advantages: [
      { num: "100%", label: "Total immersion, no filter" },
      { num: "24-48h", label: "Guaranteed response time" },
      { num: "360°", label: "Complete internal & external view" },
      { num: "∞", label: "All business sectors" },
    ],
    testimonialsSubtitle: "Testimonials",
    testimonialsTitle: "The trust of our clients",
    testimonials: [
      { quote: "In three weeks their auditor saw what our reports had hidden for two years. A much-needed wake-up call.", author: "Site Director", company: "Industrial group, Northern France" },
      { quote: "We cut warehouse turnover by almost a third thanks to their recommendations.", author: "HR Director", company: "National logistics provider" },
      { quote: "Exemplary rigour and discretion across our 40 stores. A true strategic partner.", author: "Operations Director", company: "Retail network" },
    ],
    ctaSubtitle: "Take Action",
    ctaTitle: "Get contacted by an expert",
    ctaDesc: "Fill in the form below and a Employé Incognito consultant will get back to you within 24 to 48 hours to discuss your needs.",
    immersiveNew: "For all businesses",
    immersiveTitle: "Mystery Employee — For every business",
    immersiveDesc: "Our mystery employee service is designed for any business that wants to understand its internal reality. Retail, banking, healthcare, government… our auditor integrates into your teams to reveal invisible dysfunctions.",
    immersiveCta: "Discover this service",
    immersiveClient: "Mystery Guest",
    immersiveClientDesc: "Evaluates the customer experience from outside",
    immersiveEmploye: "Mystery Employee",
    immersiveEmployeDesc: "Infiltrates your teams, all sectors",
    enterpriseSubtitle: "All Sectors",
    enterpriseTitle: "Mystery employee for every business",
    enterpriseDesc: "We operate in every sector where internal operations impact performance.",
    enterpriseSectors: [
      { title: "Retail & Shops", desc: "Evaluate customer welcome, sales advice, team management and procedure compliance in store." },
      { title: "Banking & Insurance", desc: "Analyse branch welcome quality, regulatory process compliance and customer relations." },
      { title: "Healthcare & Clinics", desc: "Observe patient care, care team coordination and internal organisation." },
      { title: "Public Sector & Government", desc: "Evaluate public reception, service efficiency and inter-department communication." },
    ],
  },

  // About page
  about: {
    seoTitle: "About — Hospitality Mystery Audit Firm",
    seoDesc: "Discover Employé Incognito, a consulting firm specialising in mystery audits for the hotel, restaurant and tourism industries. Discretion, rigour, excellence.",
    subtitle: "About",
    title: "An expert eye in service of excellence",
    desc: "Employé Incognito is a consulting firm specialising in mystery audits and immersive mystery employee missions. With deep roots in hospitality, restaurants and tourism, we now operate across all business sectors. Our mission: to reveal the excellence potential of every organisation.",
    missionTitle: "Our Mission",
    missionP1: "To evaluate with rigour and discretion the entire customer journey and internal operations of businesses — hospitality, restaurants, tourism, retail, banking, healthcare and more — providing strategic analyses that elevate service standards.",
    missionP2: "We act as an invisible yet precise eye, identifying every improvement opportunity to transform the guest experience into a competitive advantage.",
    visionTitle: "Our Vision",
    visionP: "To become the leading reference for mystery audits in the hospitality sector in France and internationally, supporting establishments towards operational excellence and optimal guest satisfaction.",
    valuesSubtitle: "Our Values",
    valuesTitle: "The pillars of our commitment",
    values: [
      { title: "Discretion", desc: "Our auditors blend into the environment, behaving like genuine, discerning guests." },
      { title: "Rigour", desc: "Every criterion is evaluated using precise and objective assessment frameworks." },
      { title: "Excellence", desc: "We align with international standards for premium hospitality." },
      { title: "Analysis", desc: "Strategic insights for an in-depth understanding of the guest experience." },
      { title: "Performance", desc: "Concrete and measurable recommendations for continuous improvement." },
    ],
    specSubtitle: "Specialisation",
    specTitle: "From hospitality to every business",
    specDesc: "Building on our deep expertise in premium hospitality and restaurants, we have expanded our know-how to all business sectors. Our immersive mystery employee service is designed for any business seeking to understand its internal reality: retail, banking, healthcare, government, industry.",
    specCta: "Get contacted by an expert",
  },

  // Services page
  services: {
    seoTitle: "Services — Immersive audits for all industries",
    seoDesc: "Discover our tailored immersive audits: retail, industry, services, healthcare, call centres, hospitality. Strategic reports and measurable improvement plans.",
    subtitle: "Our Services",
    title: "Immersive audits for every type of business",
    desc: "Whatever your industry, our undercover employees integrate into your teams to reveal what reporting cannot show. A rigorous, discreet approach tailored to each organisation.",
    requestAudit: "Request an Audit",
    readySubtitle: "Ready to start?",
    readyTitle: "Reveal the reality of your business",
    readyDesc: "Our experts design the immersion tailored to your sector, your size and your operational challenges.",
    readyCta: "Request Your Personalised Audit",
    list: [
      {
        title: "Multi-sector Immersive Audits",
        desc: "Field immersion in any type of business — retail, industry, services, healthcare, call centres, administration — to reveal what reporting does not show.",
        items: [
          "Retail & commerce (boutiques, chains, mass distribution)",
          "Industry & production (workshops, manufacturing sites)",
          "B2B services & corporates (HQs, agencies, firms)",
          "Healthcare & medico-social (clinics, centres, care homes)",
          "Call centres & customer relations",
          "Banking, insurance & public administration",
        ],
      },
      {
        title: "Hospitality & Restaurant Audits",
        desc: "Our historical expertise: a comprehensive evaluation of the guest journey in premium hospitality, restaurants and tourism.",
        items: [
          "Booking process and welcome",
          "Room, service and dining quality",
          "Cleanliness, maintenance and operational compliance",
          "Sales techniques and upselling in the dining room",
          "Resorts, spas, travel agencies and concierge services",
          "Overall guest experience and loyalty",
        ],
      },
      {
        title: "Network & Multi-site Audits",
        desc: "Detect gaps between your sites, branches or points of sale before they durably affect your profitability and brand image.",
        items: [
          "Standards consistency across sites",
          "Real application of procedures and training",
          "Quality of frontline management",
          "Social climate and turnover per location",
          "Comparative commercial performance",
          "Mapping of strengths and weaknesses",
        ],
      },
      {
        title: "Strategic Reports",
        desc: "Comprehensive, factual and confidential deliverables to decide and act with precision.",
        items: [
          "Overall and category performance score",
          "Detailed analysis of each evaluated criterion",
          "Sector benchmarking",
          "Identification of priority improvement areas",
          "Personalised strategic action plan",
          "Progress tracking and measurement",
        ],
      },
    ],
  },

  // Methodology page
  methodology: {
    seoTitle: "Methodology — 5-Step Mystery Audit Process",
    seoDesc: "Our 5-step mystery audit methodology: needs analysis, criteria definition, mystery visit, data analysis and personalised strategic report.",
    subtitle: "Our Methodology",
    title: "A rigorous 5-step process",
    desc: "A structured, proven and adaptable approach to guarantee strategic and measurable results.",
    stepLabel: "Step",
    steps: [
      { title: "Needs Analysis", desc: "We discuss with you to understand your objectives, challenges and the specificities of your establishment. This scoping phase is essential for designing a tailored audit." },
      { title: "Criteria Definition", desc: "Together, we build a personalised evaluation framework, adapted to your positioning and industry standards. Each criterion is weighted according to your priorities." },
      { title: "Mystery Visit", desc: "Our auditors, trained in premium hospitality codes, present themselves as genuine guests. They evaluate every touchpoint with objectivity and discretion." },
      { title: "Data Analysis", desc: "Observations are compiled and analysed in depth. We identify strengths, weaknesses and improvement opportunities for each evaluated criterion." },
      { title: "Report & Recommendations", desc: "You receive a comprehensive strategic report with a performance score, detailed analysis and actionable improvement plan with priority recommendations." },
    ],
    readySubtitle: "Ready to start?",
    readyTitle: "Launch your first mystery audit",
    readyDesc: "Contact us to discuss with an expert and define the audit best suited to your establishment.",
    readyCta: "Get contacted by an expert",
  },

  // Contact page
  contact: {
    seoTitle: "Contact — Request Your Personalised Mystery Audit",
    seoDesc: "Contact Employé Incognito for a tailored hotel mystery audit. Response within 24-48h. Email, phone or contact form.",
    subtitle: "Contact",
    title: "Request Your Personalised Audit",
    desc: "Fill in the form below and a Employé Incognito consultant will get back to you within 24 to 48 hours to discuss your needs.",
    coordsTitle: "Contact Details",
    emailLabel: "Email",
    phoneLabel: "WhatsApp / Phone",
    hqLabel: "Headquarters",
    hqValue: "Paris, France",
    reactivityTitle: "Responsiveness",
    reactivityText: "Every request is handled with the utmost care. An expert will get back to you within",
    reactivityDelay: "24 to 48 business hours",
    reactivityEnd: "to define your needs together.",
  },

  // FAQ page
  faq: {
    seoTitle: "FAQ — Frequently Asked Questions about Mystery Audits & Mystery Employee",
    seoDesc: "Find answers to all your questions about mystery audits and mystery employee services: cost, process, frequency, cities of intervention. Employé Incognito supports you.",
    badge: "Frequently Asked Questions",
    heroTitle: "Everything you need to know about",
    heroHighlight: "mystery audits & mystery employee",
    heroDesc: "Find answers to the most frequently asked questions about our mystery audit and immersive mystery employee services for the hotel, restaurant and tourism industries.",
    goFurtherSubtitle: "Go Further",
    goFurtherTitle: "Useful Resources",
    links: [
      { title: "Our Services", desc: "Discover our hotel, restaurant and tourism audits" },
      { title: "Our Methodology", desc: "The 5 steps of our audit process" },
      { title: "Our Cities", desc: "Over 20 cities covered in France" },
      { title: "Blog", desc: "Articles and advice on guest experience" },
      { title: "Hotel Audit Paris", desc: "Mystery audit in the capital" },
      { title: "Contact Us", desc: "Free quote within 24-48h" },
    ],
    notListedSubtitle: "Your question isn't listed?",
    notListedTitle: "Contact us directly",
    notListedDesc: "A Employé Incognito consultant will respond within 24 to 48 hours.",
    notListedCta: "Contact Us",
    items: [
      { question: "What is a mystery audit?", answer: "A mystery audit (or mystery shopping) involves sending an anonymous evaluator to your establishment to experience the guest journey from start to finish. The auditor behaves like a real guest and evaluates every step: booking, welcome, service, room, dining, check-out. A detailed report with a performance score and concrete recommendations is then delivered." },
      { question: "How much does a hotel mystery audit cost?", answer: "The cost of a mystery audit varies depending on the type of establishment, the number of criteria evaluated and the duration of the assignment. Employé Incognito offers tailored audits to suit every budget. Contact us to receive a free personalised quote within 24 to 48 hours." },
      { question: "How does a mystery audit with Employé Incognito work?", answer: "Our methodology follows 5 steps: 1) Analysis of your needs and objectives, 2) Definition of personalised evaluation criteria, 3) Mystery visit by a trained auditor, 4) In-depth analysis of collected data, 5) Delivery of a strategic report with performance score and actionable improvement plan." },
      { question: "What types of establishments can benefit from a mystery audit?", answer: "Employé Incognito operates in hospitality (3 to 5 stars and palaces), restaurants (fine dining, bistros, brasseries), resorts and spas, travel agencies and premium tourism. Through our mystery employee service, we also work with retail, banking, healthcare, government and any business seeking to evaluate its internal operations." },
      { question: "Is the mystery audit truly anonymous?", answer: "Yes, absolute discretion is at the heart of our approach. Our auditors are trained professionals who behave exactly like ordinary guests. No staff member is warned of the visit. This authenticity guarantees the reliability of our evaluations." },
      { question: "In which cities do you operate?", answer: "Employé Incognito operates in over 20 major French cities: Paris, Lyon, Marseille, Bordeaux, Nice, Cannes, Monaco, Toulouse, Strasbourg, Lille, Nantes, Montpellier, Courchevel, Megève, Deauville, Biarritz, Aix-en-Provence, Annecy, Toulon, La Rochelle, Saint-Tropez, and many more. We travel throughout France and internationally upon request." },
      { question: "What is the difference between a mystery audit and a standard quality audit?", answer: "Unlike a standard quality audit (announced and based on standards), the mystery audit evaluates the real guest experience without staff being warned. It measures subjective perception, emotions, attention to detail and service consistency. It is the only tool capable of capturing the complete reality of the guest experience." },
      { question: "How often should mystery audits be conducted?", answer: "We recommend a continuous monitoring programme rather than one-off evaluations. A minimum of 2 to 4 audits per year allows you to measure progress, identify seasonal regressions and support your teams over time. The ideal frequency depends on the size of your establishment and your objectives." },
      { question: "How do mystery audit results improve online reviews?", answer: "Negative reviews often result from an accumulation of invisible micro-disappointments in daily operations. The mystery audit precisely identifies these weak points before they impact your reviews on TripAdvisor, Google or Booking. Our clients typically see a 15 to 25% improvement in their satisfaction score after an audit programme." },
      { question: "How long does it take to receive the audit report?", answer: "The complete strategic report is delivered within 5 to 10 business days after the mystery visit. It includes an overall performance score, detailed analysis by criterion, comparisons with industry standards and a concrete improvement plan with priority actions." },
      { question: "What is a mystery employee?", answer: "A mystery employee is an immersive audit in which a Employé Incognito auditor is temporarily integrated into your team (receptionist, waiter, commis…) with management's approval. They observe from within the organisation, team communication, management quality, standard compliance and operational pressure. This service reveals dysfunctions invisible to management." },
      { question: "What is the difference between a mystery guest and a mystery employee?", answer: "The mystery guest evaluates the experience from the client's perspective: welcome, service, atmosphere, perceived quality. The mystery employee immerses themselves in the team to analyse the internal reality: management, cohesion, procedure compliance, operational pressure. Both approaches combined provide a 360° view of your establishment." },
      { question: "How does a mystery employee mission work?", answer: "The mission follows 5 steps: 1) Definition of the role and objectives with management, 2) Discreet immersion of the auditor into the team, 3) On-site observation of practices and organisation, 4) Writing of a detailed confidential report, 5) Presentation of strategic recommendations to improve internal operations and strengthen operational excellence." },
    ],
  },

  // Blog page
  blog: {
    seoTitle: "Blog — Mystery Shopping & Luxury Hospitality Expertise",
    seoDesc: "Expert articles on mystery shopping, hotel audits, fine dining and luxury tourism. Insights and analysis by Employé Incognito.",
    subtitle: "Blog & Resources",
    title: "Mystery audit and luxury hospitality expertise",
    desc: "Find our expert analyses, professional advice and insights into trends in the hotel, restaurant and premium tourism sectors.",
    ctaSubtitle: "Take Action",
    ctaTitle: "Ready to evaluate your guest experience?",
    ctaDesc: "Our experts are at your disposal to discuss your challenges and offer a tailored audit.",
    ctaCta: "Request Your Personalised Audit",
    readTime: "read",
    relatedArticles: "Related Articles",
    backToBlog: "Back to Blog",
    requestAudit: "Request Your Audit",
    discoverCities: "Discover our audits by city",
    allCities: "All cities →",
    breadcrumbHome: "Home",
  },

  // Cities page
  cities: {
    seoTitle: "Mystery Audits Across France",
    seoDesc: "Employé Incognito operates in all major French cities: Paris, Lyon, Cannes, Monaco, Courchevel... Discover our local mystery audits.",
    badge: "Our Locations",
    heroTitle: "Mystery audits across",
    heroHighlight: "France",
    heroDesc: "Employé Incognito operates in over 20 French cities. Discover our mystery audit services tailored to each destination.",
    notListedSubtitle: "Your city isn't listed?",
    notListedTitle: "We operate throughout France",
    notListedDesc: "Contact us to discuss your needs. Employé Incognito travels throughout France and internationally.",
    notListedCta: "Contact Us",
  },

  // City page
  cityPage: {
    breadcrumbHome: "Home",
    breadcrumbCities: "Our Cities",
    requestAudit: "Request an audit in",
    servicesAt: "Our services in",
    customAuditsFor: "Tailored mystery audits for",
    hotelAudit: "Hotel Audit in",
    restaurantAudit: "Restaurant Audit in",
    tourismAudit: "Tourism Audit in",
    whySubtitle: "Why a mystery audit",
    whyTitle: "Why choose Employé Incognito in",
    resourcesSubtitle: "Resources",
    resourcesTitle: "Articles related to your approach",
    ctaSubtitle: "Take Action",
    ctaTitle: "Plan your mystery audit in",
    ctaDesc1: "Contact us to discuss your specific needs in",
    ctaDesc2: "A Employé Incognito consultant will respond within 24 to 48 hours.",
    ctaQuote: "Request a free quote",
    ctaServices: "Discover Our Services",
    otherSubtitle: "Our Other Destinations",
    otherTitle: "Discover our audits in other cities",
    allCities: "View All Cities",
  },

  // Employé Mystère
  employeMystere: {
    seoTitle: "Mystery Employee — Immersive Audit for All Businesses | Employé Incognito",
    seoDesc: "Our mystery employee service is for every business: hospitality, retail, banking, healthcare, government. An auditor embedded in your team to reveal internal reality.",
    badge: "For all businesses",
    heroTitle: "Reveal the internal reality of your business…",
    heroHighlight: "unfiltered.",
    heroDesc: "Our mystery employee service places an auditor at the heart of your teams — hospitality, retail, banking, healthcare or government — to reveal operational reality invisible from management.",
    ctaPrimary: "Request an Immersive Audit",
    ctaSecondary: "Our Other Services",
    conceptSubtitle: "The Concept",
    conceptTitle: "The mystery employee for every business",
    conceptP1: "A Employé Incognito auditor is temporarily embedded in your team — sales associate, receptionist, team member — with management approval. They observe from the inside: organisation, team communication, management quality and adherence to standards.",
    conceptP2: "Inspired by the 'undercover boss' concept, this unique approach applies to all business sectors: hospitality, retail, banking, healthcare, government, industry. It reveals what traditional audits cannot see.",
    visionClient: "Mystery Client",
    visionClientDesc: "Evaluates the guest experience from outside",
    visionEmploye: "Mystery Employee",
    visionEmployeDesc: "Reveals internal reality from inside",
    benefitsSubtitle: "The Benefits",
    benefitsTitle: "What the immersive audit reveals",
    benefits: [
      { title: "Internal Dysfunctions", desc: "Identify invisible flaws: failing processes, bottlenecks, time losses invisible to management." },
      { title: "Service Quality Gaps", desc: "Detect discrepancies between defined standards and day-to-day operational reality." },
      { title: "Organisational Issues", desc: "Analyse task distribution, inter-service coordination and priority management." },
      { title: "Team Cohesion", desc: "Evaluate internal communication, mutual support and actual working atmosphere." },
      { title: "Operational Excellence", desc: "Strengthen your standards by aligning field reality with your vision of excellence." },
    ],
    processSubtitle: "The Process",
    processTitle: "A 5-step mission",
    stepLabel: "Step",
    steps: [
      { title: "Discreet Immersion", desc: "Our auditor joins your team under an identity agreed with management. No staff member is informed of their true mission." },
      { title: "Field Observation", desc: "Over several days, the auditor lives the daily reality of your establishment: rhythms, constraints, interactions, operational pressure." },
      { title: "Practice Analysis", desc: "Every observation is documented using our evaluation framework: management, communication, adherence to standards, organisation." },
      { title: "Confidential Report", desc: "A detailed and strictly confidential report is delivered to management with objective findings from the immersion." },
      { title: "Strategic Recommendations", desc: "Concrete, prioritised recommendations to transform weaknesses into performance levers." },
    ],
    premiumQuote: "Employé Incognito reveals what indicators cannot show.",
    premiumAuthor: "Employé Incognito",
    ctaSubtitle: "Take Action",
    ctaTitle: "Request your immersive audit",
    ctaDesc: "Fill in the form below and a Employé Incognito consultant will get back to you within 24 to 48 hours to discuss your immersive audit project.",
  },

  // 404 page
  notFound: {
    title: "Page Not Found",
    desc: "The page you are looking for does not exist or has been moved. Return to the homepage to continue browsing.",
    backHome: "Back to Home",
    contact: "Contact Us",
  },

  // WhatsApp
  whatsapp: {
    message: "Hello, I would like information about your mystery audits.",
    label: "Contact us on WhatsApp",
  },
};
